import React from "react";

const serviceCategories = [
  {
    category: "Personal Care",
    services: [
      {
        title: "Personalized Daily Assistance",
        description: "Professional Nursing support available for bathing, grooming, and dressing—offering you a helping hand while respecting your independence and dignity."
      },
      {
        title: "Medication Management",
        description: "Never worry about missing a dose. We provide timely medication reminders and supervision to ensure your health routine stays on track."
      },
      {
        title: "24-Hour Staff Availability",
        description: "Peace of mind knowing that trained caregivers are on-site 24/7 to assist with ADLs or emergencies, day or night."
      }
    ]
  },
  {
    category: "Lifestyle & Dining",
    services: [
      {
        title: "Nutritious Home-Cooked Meals",
        description: "Enjoy three healthy, chef-prepared meals a day plus snacks. We handle the shopping, cooking, and cleanup so you can enjoy the food."
      },
      {
        title: "Housekeeping & Laundry",
        description: "Say goodbye to chores. We provide regular room cleaning, linen changes, and personal laundry services so you can focus on relaxing."
      },
      {
        title: "Social & Recreational Activities",
        description: "Stay engaged with daily planned activities, social gatherings, and games designed to keep our community active and connected."
      }
    ]
  },
  {
    category: "Mobility & Access",
    services: [
      {
        title: "Scheduled Transportation",
        description: "Need a ride? We provide safe transportation to doctor's appointments, local shopping centers, religious services, and community events."
      }
    ]
  }
];

export default function Services() {
  return (
    <section id="services" className="services">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <p className="section-subtitle">
          Comprehensive care designed to enhance your quality of life
        </p>
        {serviceCategories.map((cat, catIndex) => (
          <div key={catIndex} className="service-category">
            <h3 className="category-title">{cat.category}</h3>
            <div className="services-grid">
              {cat.services.map((service, index) => (
                <div key={index} className="service-card">
                  <h4 className="service-title">{service.title}</h4>
                  <p className="service-description">{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
